// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectMark_wrapper__tjuoS","radio":"SelectMark_radio__IFkAA","checked":"SelectMark_checked__UUhZH","symbol":"SelectMark_symbol__R73fS","input":"SelectMark_input__7z+2R"};